// Build URLs for configured APIs
export function initialize(appInstance) {
  const ENV = appInstance.resolveRegistration('config:environment');
  let apiHostBuilder = appInstance.lookup('service:api-host-builder');
  const isSsr = appInstance.lookup('service:ssr')?.isSsr;
  const {
    DEFAULT_PROTOCOL: FASTBOOT_PROTOCOL,
    EXPOSED_DEFAULT_PROTOCOL: FASTBOOT_EXPOSED_PROTOCOL,
  } = ENV.APP.FASTBOOT;
  Object.keys(ENV.APP.API).forEach(api => {
    const API = ENV.APP.API[api];
    const useFastBootConfig = isSsr && API.FASTBOOT;
    API.URL = apiHostBuilder.build(
      useFastBootConfig ? API.FASTBOOT.HOST : API.HOST,
      useFastBootConfig ? API.FASTBOOT.PORT : API.PORT,
      isSsr && FASTBOOT_PROTOCOL
    );
    API.EXPOSED_URL = apiHostBuilder.build(
      API.HOST,
      API.PORT,
      isSsr && FASTBOOT_EXPOSED_PROTOCOL
    );
  });
}

export default {
  initialize,
};
